// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5207) return "static/chunks/5207-545dca34b3d5e61f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1133":"datadogRecorder","7337":"ad2866b8","8445":"bc98253f","9050":"datadogProfiler"}[chunkId] || chunkId) + "." + {"1133":"f5b19954e66978a3","1411":"9a3ba646e0060601","5893":"ba99a8e1abd385b7","7166":"b29c54fa6aad6022","7337":"bd3bce0543804603","8445":"75c6412bdb10a1f9","9050":"937f8fef5ba2153a","9955":"dffc80b10f100e49"}[chunkId] + ".js";
};